import { colors } from '@factorialco/deprecated-design-system'
import { BaseEdge, EdgeProps, getSmoothStepPath } from '@xyflow/react'

const Edge = ({
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
}: EdgeProps) => {
  const [edgePath] = getSmoothStepPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  })

  return <BaseEdge path={edgePath} style={{ strokeWidth: 2, stroke: colors.grey400 }} />
}

export default Edge
